import Header from "../Header/Header";
import React, {useEffect, useState} from "react";
import {IRental} from "../RentalList/RentalInterfaces";
import axios from "axios";
import {HOST} from "../../utils/vars";
import GetDaysCount, {ExtraProducts, ExtraProductsCost} from "../../utils/utils";
import {Link} from "react-router-dom";

import '../RentalDetails/RentalDetails.css'
import Loading from "../Loading/Loading";


const FullReport = () => {
  const [rentals, setRentals] = useState<IRental[]>([]);
  const [productsCost, setProductsCost] = useState<number>(0);
  const [extraProductsCost, setExtraProductsCost] = useState<number>(0);
  const [reportStartDate, setReportStartDate] = useState<Date>(() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  });
  const [reportEndDate, setReportEndDate] = useState<Date>(new Date());
  const [loading, setLoading] = useState(false);

  axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  const calcDate = (days: number) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date;
  };

  const fetchData = async () => {
    try {
      const [rentals] = await Promise.all([
        axios.get(`${HOST}/api/v1/rentals`),
      ]);

      setRentals(rentals.data);
      // console.log(rentals);
    } catch (error) {
      // console.log(error);
      console.error('Error in getting data');
    }
  };

  const getProductsCost = async () => {
    let cost = 0;
    if (!rentals) return;
    rentals.filter((rental) => rental.status === 'закрыт')
    .forEach((rental) => {
      cost += (GetDaysCount(rental.start_date, rental.end_date) * Number(rental.price_per_day));
    })
    setProductsCost(cost);
  };

  const getExtraProductsCost = async () => {
    let cost = 0;
    if (!rentals) return;
    rentals.filter((rental) => rental.status === 'закрыт')
      .forEach((rental) => {
        cost += ExtraProductsCost(rental);
      })
    setExtraProductsCost(cost);
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
    setLoading(false);
  }, []);

  useEffect(() => {
    getProductsCost();
    getExtraProductsCost();
  });



  return (
    <div>
      {loading && (
        <Loading/>
      )}
      <Header/>

      <div className="row mb-6 rental-section">
        <div className="col-3">
          <button type="button" className="btn btn-light" style={{marginRight: '1rem'}}
                  onClick={() => setReportStartDate(calcDate(30))}>Мiсяць</button>
          <button type="button" className="btn btn-light" style={{marginRight: '1rem'}}
                  onClick={() => setReportStartDate(calcDate(180))}>Пiв року</button>
          <button type="button" className="btn btn-light" style={{marginRight: '1rem'}}
                  onClick={() => setReportStartDate(calcDate(365))}>Рiк</button>
        </div>
      </div>

      <div className="row mb-6 rental-section">
        Звiт
        <div className="col-md-3">
            <label className="form-label">з </label>
            <input
              type="date"
              className="form-control"
              value={reportStartDate.toISOString().split('T')[0]}
              onChange={e => setReportStartDate(new Date(e.target.value))}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">по </label>
            <input
              type="date"
              className="form-control"
              value={reportEndDate.toISOString().split('T')[0]}
              onChange={e => setReportEndDate(new Date(e.target.value))}
            />
          </div>
        </div>

        <table className="table table-hover">
          <thead className="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Продукт</th>
            <th scope="col">Початок оренди</th>
            <th scope="col">Кiлькiсть дней</th>
            <th scope="col">Вартiсть оренди</th>
            <th scope="col">Додатковi продукти</th>
            <th scope="col">Вартiсть доп. продуктiв</th>
          </tr>
          </thead>
          <tbody>
          {rentals.filter((rental) => rental.status === 'закрыт')
            .map((rental) => (
              <tr key={rental.id}>
                <th scope="row"><Link to={`/rental/${rental.id}`}>{rental.id}</Link></th>
                <td>{rental.product_name}</td>
                <td>{new Date(rental.start_date).toLocaleDateString('ru-RU')}</td>
                <td>{GetDaysCount(rental.start_date, rental.end_date)}</td>
                <td>{GetDaysCount(rental.start_date, rental.end_date) * Number(rental.price_per_day)}</td>
                <td>{ExtraProducts(rental)}</td>
                <td>{ExtraProductsCost(rental)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="button-group mt-3 text-end">
          Всього за продукты: <strong>{productsCost}</strong>
        </div>
        <div className="button-group mt-3 text-end">
          Всього за додатковi продукты: <strong>{extraProductsCost}</strong>
        </div>
        <div className="button-group mt-3 text-end">
          Всього: <strong>{productsCost + extraProductsCost}</strong>
        </div>
      </div>
      );
      };

      export default FullReport;